import { ILatLng } from '@mopla/data-models';

export const GERMANY_CENTER: ILatLng = {
	lat: 51.1642292,
	lng: 10.4541194,
};
